import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {TextInput, TextInputError} from './reduxForm.style';

export class RenderNumberInput extends PureComponent {
  render() {
    const {input, min, max, meta: { touched, error }, dataInitializedFromStorage} = this.props;
    const renderError = (touched || dataInitializedFromStorage) && error &&
      <TextInputError>
        {
          typeof error === 'string' ?
            <FormattedMessage id={error === 'required' ? `form.${input.name}.required` : error} /> :
            <FormattedMessage
              id={error.id}
              values={error.props}
            />
        }
      </TextInputError>;
    return (
      <div>
      <TextInput
        {...input}
        type="number"
        min={min}
        max={max}
        error={(touched || dataInitializedFromStorage) && !!error}
      />
        {renderError}
      </div>
    );
  }
}

RenderNumberInput.propTypes = {
  input: PropTypes.object.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  dataInitializedFromStorage: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  })
};

export default RenderNumberInput;



// WEBPACK FOOTER //
// ./components/ReduxForm/RenderNumberInput.js